import { AnalyticsContext } from '@carvana/eventable-clickstream';
import cx from 'classnames';
import { useContext, memo } from 'react';
import HeroContext from '@/vdp/Hero/HeroContext';
import SpinnerLoader from '@/vdp/Hero/SpinnerLoaderMfe';
import { SPINNER_ENGAGED } from '~/constants/Events';
import Sections from '~/constants/vdp/sections';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import debounce from '~/utilities/debounce';
import HeroBadge from '../../HeroBadge';
import HeroVehicleInfo from '../../HeroVehicleInfo';
import StaticVehicle from '../StaticVehicle';

function Spinner() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { spinnerReady, isSpinnerDisabled } = useContext(SpinnerContext);
  const { hasSpinnerOverflow } = useContext(HeroContext);

  const handleEngagement = debounce(() => {
    trackEvent(SPINNER_ENGAGED);
  }, 300);

  return (
    <div
      className={cx(
        'no-zoom grid w-full max-w-full border-b border-t border-grey-2 l:grid-cols-[1fr_332px] l:gap-3xl l:p-3xl',
        { 'h-auto': hasSpinnerOverflow }
      )}
    >
      <div className="spinner-size-parent grid aspect-video max-h-full w-full overflow-hidden l:min-h-[375px] l:rounded-[6px]">
        <div className="pointer-events-none z-10 col-span-full row-span-full p-16">
          <HeroBadge showTimer />
        </div>
        <StaticVehicle
          isVisible={!spinnerReady.isLoaded || isSpinnerDisabled}
        />
        <div
          data-analytics-id={null}
          data-nav-section={Sections.Spinner}
          className={cx('col-span-full row-span-full', {
            'is-error': spinnerReady.error
          })}
          id={Sections.Spinner}
          onClick={handleEngagement}
          onTouchEnd={handleEngagement}
        >
          {isSpinnerDisabled ? null : <SpinnerLoader />}
        </div>
      </div>
      <HeroVehicleInfo />
    </div>
  );
}

export default memo(Spinner);
